import React from 'react';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { likedProductById, removeLikeFromProduct } from '../../services';
import {
  addGuestLike,
  addLikeLocal,
  removeGuestLike,
  removeLikeLocal,
} from '../../redux/slices/likedProductSlice';
import { LikeButtonProps } from '../interfaces';
import './likeButton.scss';

const LikeButton: React.FC<LikeButtonProps> = ({ productId, iconSize = 20 }) => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.user.user?.id);
  const likedProductIds = useAppSelector((state) => state.likedProduct.likedProductCountAndIds.ids);
  const isLiked = likedProductIds.includes(productId);

  const toggleLike = async () => {
    if (!userId) {
      dispatch(isLiked ? removeGuestLike(productId) : addGuestLike(productId));
      return;
    }

    if (isLiked) {
      dispatch(removeLikeLocal(productId));
      dispatch(removeLikeFromProduct({ productId, userId }))
        .unwrap()
        .catch(() => {
          dispatch(addLikeLocal(productId));
        });
    } else {
      dispatch(addLikeLocal(productId));
      dispatch(likedProductById({ productId, userId }))
        .unwrap()
        .catch(() => {
          dispatch(removeLikeLocal(productId));
        });
    }
  };

  return (
    <button
      type="button"
      className={`like-button ${isLiked ? 'is-liked' : ''}`}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleLike();
      }}
      aria-label={isLiked ? 'Remove from liked products' : 'Add to liked products'}
    >
      {isLiked ? (
        <HeartFilled style={{ fontSize: iconSize }} />
      ) : (
        <HeartOutlined style={{ fontSize: iconSize }} />
      )}
    </button>
  );
};

export default LikeButton;
